import React, { useEffect, useState, useContext, useRef } from 'react'
import { AuthContext } from "../../auth/authProvider.jsx";
import VersionBox from 'components/Version/VersionBox';
import { Button, Avatar, Icon, Select, MenuItem } from "@mui/material";
import { CreateInitials } from 'Utils/AvatarHelper.js';
import { NavLink } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { CreateUrl, CallGetAPI, CallPutAPI, CallDeleteAPI } from 'Utils/ApiHelper.js';
import Divider from '@mui/material/Divider';
import HelpIcon from '@mui/icons-material/Help';
import MobileClickToolTip from '../MobileClickToolTip'
import FullWidthMobileButton from '../FullWidthMobileButton';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { injectIntl, FormattedMessage, IntlShape, useIntl } from 'react-intl';

interface Props {
    routes: Array<any>
    handleDrawerToggle: () => void
    open: boolean
}

interface Group {
    generation: number
    groupId: number
    groupName: string
    groupType: string
    groupTypeId: number
    id: number
    memeberId: number
}


const SideBarMobile: React.FC<Props> = ({ routes, handleDrawerToggle, open }) => {
    const intl: IntlShape = useIntl()
    const menuRef = useRef(null)
    const userPrefRef = useRef(null)
    const authContext = useContext(AuthContext);
    const [user, setUser] = useState(null);
    const [userLevel, setUserLevel] = useState("restricted");
    const [isGutermannAdmin, setIsGutermannAdmin] = useState(false)
    const [showUserPref, setShowUserPref] = useState<boolean>(false)
    const [userGroups, setUserGroups] = useState<Array<Group>>([])
    const [selectedLanguage, setSelectedLanguage] = useState<string>(sessionStorage.getItem('language'))
    const [timeFrame, setTimeFrame] = useState<string | null>(sessionStorage.getItem("inactiveTimeframe") != "undefined" ? sessionStorage.getItem("inactiveTimeframe") : "24 Hours");
    const [filterGroup, setFilterGroup] = useState(sessionStorage.getItem('filterGroupId') ? parseInt(sessionStorage.getItem('filterGroupId')) : 0)
    const [utcOffset, setUtcOffset] = useState<string | null>(sessionStorage.getItem('utcOffset'))
    //const classes = useStyles();
    useEffect(() => {
        authContext.getUser()
            .then(function (userTemp) {
                if (sessionStorage.getItem('userLevel') === 'useradmin'
                    && window.location.hostname.includes('zonelog')
                    && sessionStorage.getItem('companyId') === '57') {
                    setIsGutermannAdmin(true)
                }
                setUser(userTemp);
                setUserLevel(window.sessionStorage.getItem('userLevel'));

            });

    }, []);

    useEffect(() => {

        const handleClickOutside = (e) => {
            if (!showUserPref) {
                if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
                    requestAnimationFrame(() => {
                        if (open && !showUserPref) {
                            console.log('hit here')
                            handleDrawerToggle();
                        }
                    });
                }
            }
        };
        if (open && !showUserPref) {
            document.addEventListener('mousedown', handleClickOutside)
        } else if (open && showUserPref) {
            document.removeEventListener('mousedown', handleClickOutside)
        }
        return (): void => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [open, showUserPref])

    useEffect(() => {
        const userId = sessionStorage.getItem('userId');
        if (showUserPref) {
            CallGetAPI(CreateUrl('/api/aquaguard/GetAllGroupsForUser?userId=' + userId), {})
                .then((data: Group[]) => {
                    setUserGroups(data)
                })
                .catch(err => {
                    console.error(err)
                    setUserGroups([])
                })
        }
    }, [showUserPref])


    const drawRoutes = (routes): React.ReactNode => {
        const mobileRoutes = ['Users', 'Sites / Areas', 'Dashboard', 'Manage Users']
        return (<ul style={{marginTop: "20px"} }>
            {routes.map(route => {
                if (mobileRoutes.includes(route.name) && route.roles.includes(userLevel)) {
                    return (
                        <NavLink key={route.name} to={route.layout + route.path} onClick={():void => {handleDrawerToggle() } }>
                            <div style={{ display: "flex", margin: "10px 0" }}>
                                <div style={{ margin: route.name === 'Sites / Areas' ? "8px 0 0 -8px" : "8px 0 0 0", color: "black" }}>
                                    <route.icon />
                                </div>
                                <h5 style={{ fontSize: "22px", margin: "6px 0 0 10px", color: "black" }}>{intl.formatMessage({ id: route.name })}</h5>
                            </div>
                        </NavLink>
                    )
                } else return null
            })}
        </ul>)
        
    }


    const signOut = ():void => {
        authContext.logout();
    }

    const toggleUserPref = ():void => {
        setShowUserPref(!showUserPref)
        if (showUserPref) {
            handleDrawerToggle()
        }
    }


    const handleLanguageChange = (e):void => {
        setSelectedLanguage(e.target.value)
    }

    const userTimeFrameChanged = (e) => {
        setTimeFrame(e.target.value)
    } 

    const filterGroupChanged = (e):void => {
        setFilterGroup(e.target.value)
    }

    const handleUtcOffsetChange = (e):void => {
        setUtcOffset(e.target.value)
    }

    const createSuccessNotification =  ():void => {
        NotificationManager.success(<FormattedMessage id='Saved Changes' />, <FormattedMessage id='Success' />);

    }

    const  createErrorNotification = ():void => {
        NotificationManager.error(<FormattedMessage id='Error Saving Changes' />, <FormattedMessage id='Check console for details' />)
    }

    const savePreferences = () => {
        setShowUserPref(false)
        handleDrawerToggle()

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                UserId: sessionStorage.getItem('userId'),
                UserGuid: sessionStorage.getItem('userGuid'),
                FilterGroupId: filterGroup,
                FlowUnits: 'l/s',
                UtcOffset: parseInt(utcOffset),
                InactiveTimeframe: timeFrame,
                GraphTotaliser: false,
                CanConfig: sessionStorage.getItem('canConfig'),
                Language: selectedLanguage
            })
        };


        CallGetAPI(CreateUrl('/api/aquaguard/SetUserPreferences'), requestOptions)
            .then(data => {
                if (data.status === undefined) {
                    // Update session store
                    window.sessionStorage.setItem("filterGroupId", filterGroup);
                    if (userGroups.length > 0 && filterGroup != 0) {
                        window.sessionStorage.setItem("filterGroupName", userGroups.filter(g => g.groupId == filterGroup)[0].groupName);
                    }
                    window.sessionStorage.setItem("flowUnits", 'l/s');
                    window.sessionStorage.setItem("utcOffset", utcOffset);
                    window.sessionStorage.setItem("inactiveTimeframe", timeFrame);
                    window.sessionStorage.setItem("graphTotaliser", false);
                    window.sessionStorage.setItem('language', selectedLanguage)
                    createSuccessNotification();
                    window.location.href = '/portal/dashboard'
                }
                else {
                    createErrorNotification();

                }
            })

            .catch(function (error) {
                createErrorNotification();
                console.error(error);
            });
    }

    return (
        <div style={{position: "fixed", zIndex: 1000, top: "50px", width: "85%"} }>
            <Modal
                show={showUserPref}
                style={{
                    width: "100% !important",
                    height: "100%",
                    marginTop: "50px",
                }}
                
            >
                <div ref={userPrefRef}>
                    <Modal.Header>
                        <Modal.Title><FormattedMessage id='User Preferences' />
                        </Modal.Title>
                        <CloseIcon fontSize="large" onClick={():void => { toggleUserPref() }} />
                    </Modal.Header>
                    <Modal.Body>
                        <Divider><FormattedMessage id='Info'/></Divider>
                        <div style={{display: "flex", width: "100%", justifyContent: "center"} }>
                            <div style={{ marginTop: "10px" }}>
                                <p><FormattedMessage id='Name'/>: <b>{user?.profile.name}</b></p>
                                <p><FormattedMessage id='Company'/>: <b>{window.sessionStorage.getItem("companyName")}</b></p>
                                <p><FormattedMessage id='User Level'/>: <b>{user?.profile.userlevel}</b></p>
                                {userGroups.length > 0 && <div>
                                    <p><FormattedMessage id='Groups'/>:</p>
                                    <ul>
                                        {userGroups.map(group => {
                                            return (<li key={group.id} style={{ fontSize: "15px" }}><b>{group.groupName}</b></li>)
                                        })}
                                    </ul>
                                </div>}
                            </div>
                        </div>
                        <Divider><FormattedMessage id='Preferences'/></Divider>
                        <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
                            <div style={{ marginTop: "10px" }}>
                                <div style={{display: "flex"} }>
                                    <p style={{ margin: "14px 10px 0 0" }}><FormattedMessage id='Language'/>:</p>
                                    <Select
                                        size="medium"
                                        style={{ width: "255px" }}
                                        value={selectedLanguage}
                                        onChange={(e):void => handleLanguageChange(e) }
                                    >
                                        <MenuItem value="en-GB"><FormattedMessage id="English" /></MenuItem>
                                        <MenuItem value="es-ES"><FormattedMessage id="Spanish" /></MenuItem>
                                        <MenuItem value="de-DE"><FormattedMessage id="German" /></MenuItem>
                                        <MenuItem value="fr-FR"><FormattedMessage id="French" /></MenuItem>
                                        <MenuItem value="pt-PT"><FormattedMessage id="Portuguese" /></MenuItem>
                                    </Select>
                                </div>
                                <div style={{ display: "flex", marginTop: "10px" }}>
                                    <div style={{ display: "flex", margin: "14px 10px 0 0" }} >
                                        <p style={{ marginRight: "3px" }}><FormattedMessage id="Set time frame" />: </p>
                                        <div style={{marginTop: "-1px"} }>
                                            <MobileClickToolTip tooltipText={intl.formatMessage({ id: "Sets the timeframe for inactive loggers recognition" })} position="left" />
                                        </div>
                                    </div>
                                    <Select
                                        id="outlined-select"
                                        value={timeFrame}
                                        size="medium"
                                        onChange={(e):void => userTimeFrameChanged(e)}
                                        style={{ width: 200 }}
                                    >
                                        <MenuItem value="6 Hours">6 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="12 Hours">12 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="24 Hours">24 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="3 Days" >3 <FormattedMessage id="Days" /></MenuItem>
                                        <MenuItem value="4 Days" >4 <FormattedMessage id="Days" /></MenuItem>
                                        <MenuItem value="7 Days">7 <FormattedMessage id="Days" /></MenuItem>
                                        <MenuItem value="14 Days">14 <FormattedMessage id="Days" /></MenuItem>

                                    </Select>
                                </div>
                                <div style={{ display: "flex", marginTop: "10px" }}>
                                    <div style={{ display: "flex", margin: "14px 10px 0 0" }} >
                                        <p style={{ marginRight: "3px" }}><FormattedMessage id="Filter Group" />: </p>
                                        <div style={{ marginTop: "-1px" }}>
                                            <MobileClickToolTip tooltipText={intl.formatMessage({ id: "Sets the group you want to filter your view to" })} position="left" />
                                        </div>
                                    </div>
                                    <Select
                                        id="outlined-select"
                                        value={filterGroup}
                                        size="medium"
                                        onChange={(e): void => filterGroupChanged(e)}
                                        style={{ width: 220 }}
                                    >
                                        <MenuItem key="0" value={0}><FormattedMessage id="None" /></MenuItem>
                                        {userGroups?.map((s, i) => {
                                            console.log(s)
                                            return <MenuItem key={i} value={s.id} > {s.groupName}</MenuItem>;
                                        })}
                                    </Select>
                                </div>
                                <div style={{ display: "flex", marginTop: "10px" }}>
                                    <div style={{ display: "flex", margin: "14px 10px 0 0" }} >
                                        <p style={{ marginRight: "3px" }}><FormattedMessage id="UTC Offset" />: </p>
                                        <div style={{ marginTop: "-1px" }}>
                                            <MobileClickToolTip tooltipText={intl.formatMessage({ id: "Sets the UTC offset for the user" })} position="left" />
                                        </div>
                                    </div>
                                    <Select
                                        id="outlined-select"
                                        value={utcOffset}
                                        size="medium"
                                        onChange={(e): void => handleUtcOffsetChange(e)}
                                        style={{ width: 223 }}
                                    >
                                        <MenuItem value="0"><FormattedMessage id="Use UTC" /></MenuItem>
                                        <MenuItem value="+1" >+1 <FormattedMessage id="Hour" /></MenuItem>
                                        <MenuItem value="+2" >+2 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="+3" >+3 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="+4" >+4 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="+5" >+5 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="+6" >+6 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="+7" >+7 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="+8" >+8 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="+9" >+9 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="+10" >+10 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="+11" >+11 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="+12" >+12 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="-1" >-1 <FormattedMessage id="Hour" /></MenuItem>
                                        <MenuItem value="-2" >-2 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="-3" >-3 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="-4" >-4 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="-5" >-5 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="-6" >-6 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="-7" >-7 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="-8" >-8 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="-9" >-9 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="-10" >-10 <FormattedMessage id="Hours" /></MenuItem>
                                        <MenuItem value="-11" >-11 <FormattedMessage id="Hours" /></MenuItem>
                                    </Select>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div style={{ display: "block", width: "100%" }} >
                            <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: 'Update User Preferences' })} color={'primary'} onClick={():void => { savePreferences() }} />
                        </div>
                    </Modal.Footer>
                </div>
            </Modal>
            <div ref={menuRef} style={{ border: "1px solid black", background: "white", width: "75%", borderBottomLeftRadius: "3px", borderBottomRightRadius: "3px" }}>
                <div style={{marginBottom: "40px"} }>
                    {routes && routes.length > 0 && drawRoutes(routes)}
                </div>
                <div style={{ display: "flex", justifyContent: "center" }} onClick={():void => toggleUserPref()}>
                    {user && <Avatar>{CreateInitials(user?.profile.name)}</Avatar>}
                    <p style={{fontWeight: 500, textDecoration: "underline", margin: "6px 0 0 10px"} }>{user?.profile.name}</p>
                </div>
               
                <div style={{display: "flex", justifyContent: "center", margin: "20px 10px"} }>
                    <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: 'Sign Out' })} color={'primary'} onClick={(): void => { signOut() }} />
                </div>
                </div>
        </div>
        
    )
}
export default SideBarMobile